import { isNil, isFunction } from "lodash-es";
import IConnection_TokenUI from "../models/IConnection_TokenUI";
import INavItem from "../models/INavItem";
import IUserTypeAccessDetail from "../models/IUserTypeAccessDetail";
import UserTypesEnum from "../models/UserTypesEnum";
import IConnection_Token from "../models/IConnection_Token";

const ADMIN_ONLY: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SALES]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const ALL_ACCESS: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const DailyRoutes: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const Orders: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const Notes: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const OrderEntry: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const Quotes: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const Templates: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const Clients: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const Shipments: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const Reports: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const BusinessProfile: IUserTypeAccessDetail = ADMIN_ONLY;

const BusinessIntegrations = BusinessProfile;

const BusinessSettings = BusinessProfile;

const Users: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const UsersVendors: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const UsersVendorsUsers: IUserTypeAccessDetail = ADMIN_ONLY;

const Catalogs: IUserTypeAccessDetail = ADMIN_ONLY;

const Inventory: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const Caches: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const PurchaseOrders: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SALES]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const Accounting: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SALES]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const Sync = Caches;

const Dashboard: IUserTypeAccessDetail = ALL_ACCESS;

const Materials = ADMIN_ONLY;
const Sources = ADMIN_ONLY;
const Forecasts = ALL_ACCESS;
const Projects = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: true,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};
const PickPackingLists = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.SALES]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: false,
        EDIT: false,
    },
};

const ShopFloor: IUserTypeAccessDetail = {
    [UserTypesEnum.ADMIN]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.INVENTORY_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHIP_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.MANAGEMENT]: {
        VIEW: true,
        EDIT: true,
    },
    [UserTypesEnum.ORDER_MGMT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SALES]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SUPPORT]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.VENDOR_SOURCE_USER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.DRIVER]: {
        VIEW: false,
        EDIT: false,
    },
    [UserTypesEnum.SHOP_FLOOR]: {
        VIEW: true,
        EDIT: true,
    },
};

const ProductionDashboard: IUserTypeAccessDetail = ADMIN_ONLY;

const hasAccess = (
    navItem: INavItem,
    isSupplierUser: boolean,
    supplierUserToken?: IConnection_TokenUI,
    vendorUserToken?: IConnection_Token,
    isVendorSourceUser?: boolean
) => {
    let userHasAccess = false;

    if (isSupplierUser) {
        if (supplierUserToken) {
            switch (supplierUserToken.User_Type?.id) {
                case UserTypesEnum.ADMIN:
                    userHasAccess = navItem.viewAccessDetail[UserTypesEnum.ADMIN]?.VIEW ?? false;
                    break;

                case UserTypesEnum.MANAGEMENT:
                    userHasAccess = navItem.viewAccessDetail[UserTypesEnum.MANAGEMENT]?.VIEW ?? false;
                    break;

                case UserTypesEnum.SALES:
                    userHasAccess = navItem.viewAccessDetail[UserTypesEnum.SALES]?.VIEW ?? false;
                    break;

                case UserTypesEnum.SUPPORT:
                    userHasAccess = navItem.viewAccessDetail[UserTypesEnum.SUPPORT]?.VIEW ?? false;
                    break;

                case UserTypesEnum.INVENTORY_MGMT:
                    userHasAccess = navItem.viewAccessDetail[UserTypesEnum.INVENTORY_MGMT]?.VIEW ?? false;
                    break;

                case UserTypesEnum.ORDER_MGMT:
                    userHasAccess = navItem.viewAccessDetail[UserTypesEnum.ORDER_MGMT]?.VIEW ?? false;
                    break;

                case UserTypesEnum.SHIP_MGMT:
                    userHasAccess = navItem.viewAccessDetail[UserTypesEnum.SHIP_MGMT]?.VIEW ?? false;
                    break;

                case UserTypesEnum.DRIVER:
                    userHasAccess = navItem.viewAccessDetail[UserTypesEnum.DRIVER]?.VIEW ?? false;
                    break;

                case UserTypesEnum.SHOP_FLOOR:
                    userHasAccess = navItem.viewAccessDetail[UserTypesEnum.SHOP_FLOOR]?.VIEW ?? false;
                    break;
            }
        }
    } else {
        if (vendorUserToken) {
            switch (vendorUserToken.User_Type?.id) {
                case UserTypesEnum.ADMIN:
                    userHasAccess = navItem.viewAccessDetail[UserTypesEnum.ADMIN]?.VIEW ?? false;
                    break;

                case UserTypesEnum.MANAGEMENT:
                case UserTypesEnum.SALES:
                case UserTypesEnum.SUPPORT:
                    userHasAccess = navItem.viewAccessDetail[UserTypesEnum.SALES]?.VIEW ?? false;
                    break;
            }
        }
    }

    if (isVendorSourceUser) {
        userHasAccess = navItem.viewAccessDetail[UserTypesEnum.VENDOR_SOURCE_USER]?.VIEW ?? false;
    }

    if (!isNil(navItem.viewAccessDetailFn) && isFunction(navItem.viewAccessDetailFn)) {
        const viewAccessDetailFnData = navItem.viewAccessDetailFn();

        if (viewAccessDetailFnData.useOverride) {
            userHasAccess = viewAccessDetailFnData.userHasAccess;
        }

        // console.log("viewAccessDetailFn", viewAccessDetailFnData);
    }

    return userHasAccess;
};

const ViewAccessService = {
    Orders,
    Notes,
    OrderEntry,
    Quotes,
    Templates,
    Clients,
    Shipments,
    Reports,
    BusinessProfile,
    BusinessIntegrations,
    BusinessSettings,
    Users,
    UsersVendors,
    UsersVendorsUsers,
    Catalogs,
    Inventory,
    Caches,
    Sync,
    Dashboard,
    Materials,
    PurchaseOrders,
    Projects,
    Sources,
    Forecasts,
    Accounting,
    DailyRoutes,
    PickPackingLists,
    ShopFloor,
    ProductionDashboard,
    ADMIN_ONLY,
    hasAccess,
};

export default ViewAccessService;
